<template>
  <div class="page-container">
    <div class="page_title">
      <div class="page_title_desc">司机端版本管理</div>
    </div>
    <el-divider></el-divider>
    <!--工具栏-->
    <div class="toolbar">
      <el-form :inline="true" :model="filterForm" size="small">
        <el-form-item label>
          <el-input
            v-model="filterForm.versionNum"
            clearable
            placeholder="请输入版本号"
          ></el-input>
        </el-form-item>
        
        <el-form-item label>
          <el-date-picker
            v-model="filterForm.publishTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="发布开始时间"
            end-placeholder="发布结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-search"
            label="搜索"
            perms="-1"
            type="primary"
            @click="handlerSearch"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-wrench"
            label="发布升级策略"
            perms="-1"
            type="primary"
            @click="showStrategy"
          />
        </el-form-item>
      </el-form>
      <el-table :data="publishList" stripe size="mini" style="width: 100%">
        <el-table-column
          label="序号"
          width="50"
          align="center"
          fixed
          type="index"
        ></el-table-column>

        <el-table-column
          label="司机端版本号"
          align="center"
          width="120"
          prop="versionNum"
        ></el-table-column>
        <el-table-column
          label="发布日期"
          prop="publishTime"
          align="center"
        ></el-table-column>
        <el-table-column
          label="升级方式"
          prop="upgradeStrategy"
          align="center"
          width="240"
        >
          <template slot-scope="scope">
            {{scope.row.upgradeStrategy ==1 ? '强制升级' :'建议升级'}}
          </template>
        </el-table-column>
        <el-table-column
          label="发布状态"
          prop="statusDesc"
          align="center"
          width="240"
        ></el-table-column>
        <el-table-column
          label="操作人"
          prop="createUser"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="120"
          fixed="right"
        >
          <template slot-scope="scope">
            <kt-button
            v-if="scope.row.status === 1"
            icon="fa fa-check"
            label="启用"
            perms="-1"
            @click="hadnleOperation(scope.row,'enableVersion')"
            type="primary"/>
          <kt-button
            v-else
            icon="fa fa-remove"
            label="停用"
            perms="-1"
            type="danger"
            @click="hadnleOperation(scope.row,'disableVersion')"/>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="refreshPageRequest"
        :current-page="pageNo"
        :page-size="pageSize"
        :total="totalSize"
        style="float: right;padding:10px"
      ></el-pagination>
    </div>
    <el-dialog 
    :visible.sync="showDialog"
      title="发布升级策略"
      :lock-scroll="true"
      :close-on-click-modal="false"
      @close="dialogCloseCallback"
      width="50%">
        <el-form :model="strategyForm" label-width="100px" size="mini" :rules="ruleForm"  ref="refForm"> 
          <el-form-item label="选择版本:" prop="versionNum">
            <el-select v-model="strategyForm.versionNum" clearable filterable placeholder="请选择升级版本" @change="changeRemark">
              <el-option v-for="item in versionList" :key="item.versionNum" :value="item.versionNum" :label="item.versionNum"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="升级方式:" prop="upgradeStrategy">
            <el-select v-model="strategyForm.upgradeStrategy" clearable filterable placeholder="请选择升级版本">
              <el-option v-for="item in strategyList" :key="item.code" :value="item.code" :label="item.name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="升级说明:">
            <div v-html="currentRemark" class="txtDesc"></div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click=" showDialog= false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitForm">确认提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import KtButton from "@/components/Core/KtButton.vue";
export default {
  data(){
    return {
      filterForm:{},
      pageNo:1,
      pageSize:10,  
      publishList:[],
      totalSize:0,
      showDialog:false,
      strategyForm:{
      },
      versionList:[],
      strategyList:[],
      currentRemark:'',
      ruleForm:{
        versionNum:[{required:true,message:'请选择版本号'}],
        upgradeStrategy:[{required:true,message:'请选择升级策略'}],
      }
    }
  },
  components:{
    KtButton
  },
  created(){
    this.getPublishList()
  },
  methods:{
    handlerSearch(){
      this.pageNo =1 
      this.getPublishList()
    },
    showStrategy(){
      this.showDialog = true
      this.getVersionList()
      this.getStrategyList()
    },
    getVersionList(){
      this.$api.appManage.mGetPublishVersionList({}).then(res=>{
        this.versionList = res.data
      })
    },
    getStrategyList(){
      this.$api.appManage.mGetStrategy({}).then((res) => {
        this.strategyList = res.data
      })
    },
    getPublishList(){
      let params = {
        pageNo:this.pageNo,
        pageSize:this.pageSize
      }
      let index = 0;
      for (let key in this.filterForm) {
        const val = this.filterForm[key];
        if (val && val !== "") {
          params["searchFieldList[" + index + "].fieldName"] = key;
          if (key === "publishTime") {
            params[
              "searchFieldList[" + index + "].rangeMinValue"
            ] = `${val[0]} 00:00:00`;
            params[
              "searchFieldList[" + index + "].rangeMaxValue"
            ] = `${val[1]} 23:59:59`;
          } else {
            params["searchFieldList[" + index + "].singleValue"] = val;
          }
          index++;
        }
      }
      this.$api.appManage.publishList({
        ...params
      }).then((res) => {
        this.publishList = res.data.dtoList
        this.totalSize = res.data.totalSize
      }).catch((err) => {
        
      });
      
    },
    changeRemark(val){
      if(!val){
        this.currentRemark = ''
        return
      }
      let selectItem = this.versionList.find((item) => {
        return item.versionNum == val
      })
      this.currentRemark = selectItem.remark
    },
    hadnleOperation(row,type){
      console.log(row);
      let txtDesc = {
        enableVersion:'启用',
        disableVersion:'停用'
      }
      this.$confirm(`确认${txtDesc[type]}该版本吗？`,'提示',{
        type:'warning'
      }).then((confirm) => {
        this.$api.appManage[type]({
        versionNum:row.versionNum,
        id:row.id
      }).then((res) => {
        this.$message({
          type:'success',
          message:txtDesc[type]+'成功！',
          offset:300
        })
        this.handlerSearch()
      })
      })
    },
    refreshPageRequest(val){
      this.pageNo = val
      this.getPublishList()
    },
    dialogCloseCallback(){
      this.$refs.refForm.resetFields()
      this.currentRemark =''
    },
    submitForm(){
      this.$refs.refForm.validate((valid) => {
        if(valid){
          this.$api.appManage.publishStrategy({
           ...this.strategyForm
          }).then((res) => {
            this.$message({
              type:'success',
              message:'发布升级策略成功！',
              offset:300
            })
            this.handlerSearch()
            this.showDialog = false
            
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container{
  box-sizing: border-box;
  padding: 10px;
}
::v-deep .txtDesc{
  ul, span, p,ol,a {
    margin-block-start:0;
    margin-block-end: 0;
  }
}
</style>